'use client'

import { SegmentError } from './_error-boundaries/segment-error.client'

type RootErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function RootError(props: RootErrorProps) {
  return <SegmentError boundary="root" {...props} />
}
